export default "__VITE_ASSET__zBryk6uj__"